import { lazy } from 'react';
import type { ToolConfig } from '@/types/tool';

export const jwtToolkitConfig: ToolConfig = {
  id: 'jwt-toolkit',
  path: '/tools/jwt-toolkit',
  meta: {
    title: 'JWT Toolkit',
    description: 'Decode, encode, verify JWT tokens with code generation and best practices. 100% client-side.',
    keywords: ['jwt', 'json web token', 'token', 'auth', 'authentication', 'decode', 'encode', 'verify'],
    icon: 'KeyRound',
    category: 'security',
    featured: true,
    gradient: 'from-orange-500 to-red-600',
  },
  component: lazy(() => import('./JwtToolkit')),
};
